module.exports = __webpack_public_path__ + "img/ship.2aa6747e.jpg";